<virtual-scroller #virtualScroller (vsEnd)="onVirtualScrollerEndEvent($event)" [childHeight]="181" [items]="listOfDrawings">
  <div
    #drawingContainer
    class="drawing-container"
    (click)="onClickDrawing(listDrawing, $event)"
    *ngFor="let listDrawing of virtualScroller.viewPortItems; trackBy: trackById"
    [class.selected]="canShowSelectedIndicator(listDrawing)"
    (mousemove)="onMouseMove($event, listDrawing)"
  >
    <div
      class="drawing"
      appDataCy="drawing"
      [appRunEventsOutsideAngular]="['drag']"
      [draggable]="isDraggable()"
      (outSideAngularEvent)="onDrawingDrag($event)"
      (dragstart)="onDrawingDragStart($event, listDrawing)"
      (dragend)="onDrawingDragEnd($event)"
    >
      <app-drawing-library-image-preview
        [drawingImage]="listDrawing.drawing.image"
        [qualityId]="listDrawing.drawing.configurations[0]?.quality?.id"
        [colorSetId]="listDrawing.drawing.configurations[0]?.colorSet?.id"
        [drawingDimensionsInPx]="listDrawing.drawing.dimensionsInPixels"
        [shouldDownloadImage]="isDrawingTypeBmp(listDrawing.drawing)"
        [hasMissingDesign]="listDrawing.drawing.missingDesign"
        [showAmountSpecifier]="canShowAmountSpecifier()"
        (mouseenter)="ellipsisLabel.ellipsisTooltip.show()"
        (hideTooltip)="ellipsisLabel.ellipsisTooltip.hide()"
        (imageDownloaded)="imageDownloaded(listDrawing.drawing, $event)"
      >
      </app-drawing-library-image-preview>

      <app-thumbnail-selected-indicator *ngIf="canShowSelectedIndicator(listDrawing)"></app-thumbnail-selected-indicator>

      <app-amount-specifier *ngIf="canShowAmountSpecifier()" [allowExceedingRequestedAmountOfOrderLineItems]="true" [listDrawing]="listDrawing" [stepSize]="productionScheduleItemMultiplier">
      </app-amount-specifier>
    </div>

    <div class="b1 drawing-name">
      <vdw-ellipsis-label class="ellipsis-label" appDataCy="drawing-name" #ellipsisLabel [text]="listDrawing.drawing.name" matTooltipPosition="above"></vdw-ellipsis-label>
    </div>
  </div>
</virtual-scroller>
